import { Component, Input, OnInit } from '@angular/core';
import { ReturnViewService } from '../../../return-view.service';
import {
  DEFAULT_IFOS_TABLE_COLUMNS,
  IFOS_DETAILS_KEY,
  IFOS_TABLE_COLUMNS,
  IFOS_TYPE_KEY,
  IFOS_TYPE_LABELS,
  INCOME_FORM_OTHER_SOURCES_SRO_KEYS,
  IncomeFormOtherSourcesKey,
  OtherSourcesTableColumn,
  SRO_TYPE,
} from '../../../../constants/income-from-other-sources-constant';

@Component({
    selector: 'app-income-from-other-sources-en-v2',
    templateUrl: './income-from-other-sources-en-v2.component.html',
    styleUrls: [
        './income-from-other-sources-en-v2.component.css',
        '../../../shared/return-view-text-fields.css',
    ],
    standalone: false
})
export class IncomeFromOtherSourcesEnV2Component implements OnInit {
  @Input() returnData: any;
  @Input() printActive: boolean = false;

  incomeFormOtherSourcesData: any[] = [];

  readonly sroTextParticulars: IncomeFormOtherSourcesKey[] = INCOME_FORM_OTHER_SOURCES_SRO_KEYS
    .filter((k) => k.type === 'text')
    .slice()
    .sort((a, b) => a.order - b.order);

  readonly sroAmountParticulars: IncomeFormOtherSourcesKey[] = INCOME_FORM_OTHER_SOURCES_SRO_KEYS
    .filter((k) => k.type === 'amount')
    .slice()
    .sort((a, b) => a.order - b.order);

  constructor(private returnViewService: ReturnViewService) { }

  getIfosType(item: any): any {
    return this.getValue(item, IFOS_TYPE_KEY);
  }

  getValue(item: any, key: string): any {
    return item ? item[key] : null;
  }

  hasValue(item: any, key: string): boolean {
    const val = this.getValue(item, key);
    return val !== null && val !== undefined && val !== '';
  }

  isSroType(ifosTypeName: any): boolean {
    return String(ifosTypeName || '').trim() === SRO_TYPE;
  }

  getIfosTypeTitle(ifosTypeName: any): string {
    const v = String(ifosTypeName || '').trim();
    return IFOS_TYPE_LABELS[v] || v;
  }

  getIfosDetails(item: any): any[] {
    return Array.isArray(item?.[IFOS_DETAILS_KEY]) ? item[IFOS_DETAILS_KEY] : [];
  }

  getTableColumns(ifosTypeName: any): OtherSourcesTableColumn[] {
    const v = String(ifosTypeName || '').trim();
    return IFOS_TABLE_COLUMNS[v] || DEFAULT_IFOS_TABLE_COLUMNS;
  }

  getTotalLabelColumnIndex(columns: OtherSourcesTableColumn[]): number {
    const firstAmountIdx = columns.findIndex((c) => c.isAmount);
    return firstAmountIdx > 0 ? firstAmountIdx - 1 : 0;
  }

  getCellValue(detail: any, column: OtherSourcesTableColumn): any {
    if (column.isComputedNet) {
      const gross = Number(this.getValue(detail, 'gross'));
      const expense = Number(this.getValue(detail, 'expense'));
      const g = isNaN(gross) ? 0 : gross;
      const e = isNaN(expense) ? 0 : expense;
      return g - e;
    }
    return this.getValue(detail, column.key);
  }

  getColumnTotal(details: any[], column: OtherSourcesTableColumn): number {
    return details.reduce((sum, detail) => {
      const val = Number(this.getCellValue(detail, column));
      return sum + (isNaN(val) ? 0 : val);
    }, 0);
  }

  getSroValue(item: any, detail: any, particular: IncomeFormOtherSourcesKey): any {
    if (particular.scope === 'parent') {
      return this.getValue(item, particular.key);
    }
    return this.getValue(detail, particular.key);
  }

  hasSroValue(item: any, detail: any, particular: IncomeFormOtherSourcesKey): boolean {
    return this.hasValue(
      particular.scope === 'parent' ? item : detail,
      particular.key
    );
  }

  ngOnInit(): void {
    const ifosData = this.returnData?.incomeData?.ifosData;
    this.incomeFormOtherSourcesData = Array.isArray(ifosData) ? ifosData : [];
  }
}
